import { render, staticRenderFns } from "./edit-incomeSupplement.vue?vue&type=template&id=4b5c38b0&scoped=true"
import script from "./edit-incomeSupplement.vue?vue&type=script&lang=ts"
export * from "./edit-incomeSupplement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c38b0",
  null
  
)

export default component.exports